import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const checkDocCategoryIsForeignCustomerAndEncoresFlagTrueRule: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
	const coverProcessId = control.get('coverProcessId')!.value;
	const documentCategory = control.get('documentCategory')!.value;
	const policyHolderId = control.get('policyHolderId')!.value;

	return  documentCategory === 'EGD01' && (!!policyHolderId || !!coverProcessId) ?
		{ checkDocCategoryIsForeignCustomerAndEncoresFlagTrueFlag: true } : null;

};
